import React from 'react';
import './Footer.css';
import CookieDeclaration from '../CookieDeclaration/CookieDeclaration';
import { useIframe } from '../../platform/iframe/useIframe';
import { isCrossDomainRememberMeEnabled } from '../../lib/identity/featureFlags';

function Footer(): React.ReactNode {
  if (useIframe().isWidgetSdkEmbed() && !isCrossDomainRememberMeEnabled()) {
    return null;
  }
  return (
    <footer className="footer">
      <CookieDeclaration />
    </footer>
  );
}

export default Footer;
